__turbopack_context__.v({
  "container": "index-module__kCBk0W__container",
  "dot": "index-module__kCBk0W__dot",
});
